// extracted by mini-css-extract-plugin
export default {"singleAttributeImage":"single-attribute-image__single-attribute-image__Avo9c"};